import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "@fontsource/noto-serif-sc/400.css"
import "@fontsource/noto-serif-sc/600.css"
import "@fontsource/ibm-plex-mono/400.css"
import App from "./App"

const root = document.getElementById("root")

if (!root) {
  throw new Error("Root element was not found")
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
